// extracted by mini-css-extract-plugin
export default {"payment-form":"Payment_payment-form__3gjvP","button-checkout":"Payment_button-checkout__hP+Js","glowing-button-checkout":"Payment_glowing-button-checkout__z9mBN"};